/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（日曜日）
 * @export
 * @interface EnableShipdaySun
 */
export interface EnableShipdaySun {
}

/**
 * Check if a given object implements the EnableShipdaySun interface.
 */
export function instanceOfEnableShipdaySun(value: object): value is EnableShipdaySun {
    return true;
}

export function EnableShipdaySunFromJSON(json: any): EnableShipdaySun {
    return EnableShipdaySunFromJSONTyped(json, false);
}

export function EnableShipdaySunFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdaySun {
    return json;
}

export function EnableShipdaySunToJSON(json: any): EnableShipdaySun {
    return EnableShipdaySunToJSONTyped(json, false);
}

export function EnableShipdaySunToJSONTyped(value?: EnableShipdaySun | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

